<script setup>
import {computed} from 'vue';
import {nl2br} from '@utils/nl2br';
import MainSiteLogo from '../Includes/menu/MainSiteLogo.vue';
import ButtonComponent from '@buttons/ButtonComponent.vue';

const props = defineProps({
    user: Object,
    route: String,
});

const text = computed(() => props.user.first_name +
    ', we\'ve received your request to reset your password and an email containing instructions has been sent to your inbox.');
</script>

<template>
    <div class="py-10 text-center container md:max-w-4xl">
        <div class="text-xl md:text-2xl mb-6 md:mb-10 leading-tight no-break" v-html="nl2br(text)"></div>
        <div class="text-center text-primary-1/75">(if you do not receive an email within the next 2 minutes please
            check
            your email spam folder)</div>
        <div class="w-40 mx-auto py-10">
            <button-component
                :href="route"
                title="Login"
                btn-class="btn-green-5 !py-4 w-full"
                text-size="text-base"
            ></button-component>
        </div>
    </div>

</template>

<style scoped>

</style>
